export class Constants {
    static PageSizes = [10, 20, 50, 100];
    static MaxNumberOfPagination = 10; // This number represents how many pagination items are allowed per view
    static AdviceOnTicketLength = 50;
}